import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray mr-3"
}
const _hoisted_5 = { class: "banner-button" }
const _hoisted_6 = { class: "bt-icon bt-icon--xs" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = { class: "bt-icon bt-icon--xs" }
const _hoisted_9 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogInfo = _resolveComponent("DialogInfo")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["banner-container", _ctx.bannerClass]
    }, [
      _createVNode("div", {
        class: _ctx.icon.class
      }, [
        _createVNode(_component_InlineSvgScoped, {
          class: {'fill-icon': _ctx.icon.class === 'icon-warning'},
          src: _ctx.icon.src,
          "aria-label": _ctx.icon.alt
        }, null, 8, ["class", "src", "aria-label"])
      ], 2),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.subtitle), 1),
        (_ctx.showLastSyncData)
          ? (_openBlock(), _createBlock("small", _hoisted_4, _toDisplayString(_ctx.bannerDetails), 1))
          : _createCommentVNode("", true),
        (_ctx.showHelp)
          ? (_openBlock(), _createBlock("small", {
              key: 1,
              class: "text-primary mr-auto help-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickHelp && _ctx.onClickHelp(...args)))
            }, _toDisplayString(_ctx.$t('AppResource.Help')), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.isVisibleSyncButton)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-rounded p-button-outlined px-4",
              disabled: !_ctx.enableSyncButton,
              onClick: _ctx.onClickSyncNow
            }, {
              default: _withCtx(() => [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: require(`@/assets/images/icons/icon-sync.svg`),
                    "aria-label": "icon-sync"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.SyncNow")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.showRetryButton)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-rounded p-button-outlined px-4",
              onClick: _ctx.onClickRetry
            }, {
              default: _withCtx(() => [
                _createVNode("span", _hoisted_8, [
                  _createVNode(_component_InlineSvgScoped, {
                    class: "icon-retry",
                    src: require(`@/assets/images/icons/icon-refresh.svg`),
                    "aria-label": "icon-retry"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Retry")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(_component_DialogInfo, {
      style: {"width":"450px"},
      "is-visible": _ctx.isVisibleHelpDialog,
      title: `${_ctx.$t('AppResource.Help')}: ${_ctx.$t('AppResourceEP.NoDeviceConnected')}`,
      buttonText: _ctx.$t('AppResource.ConfirmUpper'),
      smallButton: "",
      onHideDialog: _ctx.toggleHelpDialog
    }, {
      default: _withCtx(() => [
        _createVNode("p", {
          class: "mx-3",
          innerHTML: _ctx.$t('entrancePlant.deviceNotConnectedHelpDescription')
        }, null, 8, ["innerHTML"]),
        _createVNode("p", {
          class: "mx-3",
          innerHTML: _ctx.$t('entrancePlant.deviceNotConnectedHelpDescription2')
        }, null, 8, ["innerHTML"]),
        _createVNode("p", {
          class: "mx-3",
          innerHTML: _ctx.$t('entrancePlant.deviceNotConnectedHelpDescription3')
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    }, 8, ["is-visible", "title", "buttonText", "onHideDialog"])
  ], 64))
}